import React from 'react';
import { RadioProps as MuiRadioProps } from '@mui/material';
import * as Styled from './radio-button.styles';

const RadioButton: React.FC<MuiRadioProps> = (props) => {
  return <Styled.Radio {...props} />;
};

export default React.memo(RadioButton);
